<template>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow" v-if="model">
        <div class="icon-collection">
            <div class="container" :class="{'pt-0':paddingModifications['pt-0'], 'pb-0':paddingModifications['pb-0']}">
                <div class="row" v-if="model?.elements?.title?.value">
                    <div class="col-lg" data-aos="fade-in">
                        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                            <h2 class="title">{{ model?.elements?.title?.value }}</h2>
                        </SmartLinkStandaloneElement>
                    </div>
                </div>                
                <SmartLinkStandaloneElement :codename="type.elements.icon_items.codename">
                    <div class="row" data-aos="fade-in">
                        <IconItem v-for="item in pageStore.getListAs<IconItemModel>(model?.elements?.icon_items?.value)" :model="item"/>
                    </div>                        
                </SmartLinkStandaloneElement>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { contentTypes, type IconCollectionModel, type IconItemModel } from '~~/app/models';
const type = contentTypes.icon_collection;
const pageStore = usePageStore();
const props = defineProps<{ model: IconCollectionModel }>();

const paddingModifications = computed(() => getPaddingModifications(props.model.elements.padding_modifications__padding_modifications));
</script>